import React, { useState, useEffect } from "react";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import { CircularProgress, Tooltip } from "@mui/material";
import PackDetails from "./PackDetails";
import STBApkDetails from "./STBApkDetails";
import { callAPI } from "../../../axios";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";
import { getChainIdLS } from "../../../utils/utils";
import { useSelector } from "react-redux";

const FetchCDSNDetailsAdmin = () => {
    const [loader, setLoader] = useState(false);
    const [cdsnDetails, setCdsnDetails] = useState([]);
    const [initialLoad, setInitialLoad] = useState(false);
    const [cdsn, setCdsn] = useState("");
    const [sid, setSid] = useState("");
    const [flag, setFlag] = useState(false);

    const [cdsnFetchNowLoader, setCdsnFetchNowLoader] = useState(false)
    const { viewType } = useSelector((state) => state.viewTypeReducer);
    const { chainId } = useSelector((state) => state.chainIdReducer);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: 'onChange'
    });

    useEffect(() => {
        setCdsnDetails([]);
        setInitialLoad(false);
        setCdsn("");
        setSid("");
    }, [chainId]);

    const onSubmit = (data) => {
        setLoader(true);
        setInitialLoad(true);
        setFlag(!flag);
        callAPI(`/cdsn-info?sid=${data?.sid}&cdsn=${data?.cdsn}&pageTitle=CDSN Details`, "GET", {}, { chainId: getChainIdLS() })
            .then(function (response) {
                setLoader(false);
                setCdsnDetails(response);
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
                setLoader(false);
            });
        setCdsn(data?.cdsn);
        setSid(data?.sid);
    };
    // const renderVideoPreview = (row) => {
    //     return <Tooltip title="Fetch Now" arrow>
    //         <div className="py-2">
    //             <button type="button" className="opacity-50 pe-none un-published"> Fetch Now </button>
    //         </div>
    //     </Tooltip>
    // }

    // const loaderFunction = (pageTitle, status)=>{
    //     if (pageTitle == "CDSN Details"){
    //         setCdsnFetchNowLoader(status)
    //     }
    //     else if (pageTitle == "apk"){
    //         setApkDetailsFetchNowLoader(status)
    //     }
    //     else if (pageTitle == "pack"){
    //         setPackDetailsFetchNowLoader(status)
    //     }
    // }

    const triggerFetchNow = () => {
        setCdsnFetchNowLoader(true)
        callAPI(`/fetch?sid=${sid}&cdsn=${cdsn}&pageTitle=CDSN Details`, "GET", {}, { chainId: getChainIdLS() })
            .then(function (response) {
                setCdsnDetails(response)
                setCdsnFetchNowLoader(false)
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
                setCdsnFetchNowLoader(false)
            });
    }

    let columns;

    if (viewType === "hotelApp") {
        columns = [
            { field: "roomNumber", headerName: "Room No", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.roomNumber === null ? "N.A" : row?.roomNumber !== "" ? row?.roomNumber : 'N.A'}</p>, disableSortIcon: true },
            { field: "Bouquet_ID", headerName: "Bouquet ID", flex: 1 },
            { field: "Bouquet_Name", headerName: "Bouquet Name", flex: 1 },
            { field: "boxStatus", headerName: "Powerd On/Off", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.boxStatus ? 'Powerd On' : 'Powerd Off'} <label className={`${row?.boxStatus ? 'cdsn-status-active' : 'cdsn-status-in-active'}`}></label><br /> <span>Last Updated: {dayjs(row?.lastUpdated).format("DD MMM YYYY | hh:mm A")} </span></p>, disableSortIcon: true },
            { field: "Tv_App_Version", headerName: "Tv App Version", flex: 1 },
            { field: "KPI_Version", headerName: "KPI Version", flex: 1 },
            { field: "STB_SW_Ver", headerName: "Firmware Version", flex: 1 }
        ];
    } else {
        columns = [
            { field: "roomNumber", headerName: "Room No", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.roomNumber === null ? "N.A" : row?.roomNumber !== "" ? row?.roomNumber : 'N.A'}</p>, disableSortIcon: true },
            { field: "roomType", headerName: "Room Type", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.roomType !== null ? row?.roomType : 'N.A'}</p>, disableSortIcon: true },
            { field: "Bouquet_ID", headerName: "Bouquet ID", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.Bouquet_ID === null ? "N.A" : row?.Bouquet_ID !== "" ? row?.Bouquet_ID : 'N.A'}</p> },
            { field: "Bouquet_Name", headerName: "Bouquet Name", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.Bouquet_Name === null ? "N.A" : row?.Bouquet_Name !== "" ? row?.Bouquet_Name : 'N.A'}</p> },
            { field: "boxStatus", headerName: "Powerd On/Off", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.boxStatus ? 'Powerd On' : 'Powerd Off'} <label className={`${row?.boxStatus ? 'cdsn-status-active' : 'cdsn-status-in-active'}`}></label><br /> <span>Last Updated: {row?.lastUpdated === null ? "N.A" : dayjs(row?.lastUpdated).format("DD MMM YYYY | hh:mm A")} </span></p>, disableSortIcon: true },
            { field: "Tv_App_Version", headerName: "Tv App Version", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.Tv_App_Version === null ? "N.A" : row?.Tv_App_Version !== "" ? row?.Tv_App_Version : 'N.A'}</p>  },
            { field: "KPI_Version", headerName: "KPI Version", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.KPI_Version === null ? "N.A" : row?.KPI_Version !== "" ? row?.KPI_Version : 'N.A'}</p> },
            { field: "STB_SW_Ver", headerName: "Firmware Version", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.STB_SW_Ver === null ? "N.A" : row?.STB_SW_Ver !== "" ? row?.STB_SW_Ver : 'N.A'}</p>  }
        ];
    }

    return (
        <div className='config-hotel'>
            <div className='left-column'>
                {loader && <div className="circular-progress"><CircularProgress /></div>}
                <div className="hotel-list">
                    <form autoComplete="off" className="hotel-list-form border-bottom-0" onSubmit={handleSubmit(onSubmit)}>
                        <p className="cdsn-details">Fetch SID-CDSN Details</p>
                        <div className="row">
                            <div className="form-group-hotel col-4 mb-0">
                                <div className="floating-label">
                                    <input
                                        id="sid"
                                        maxLength={11}
                                        placeholder=""
                                        {...register("sid", {
                                            required: "Please Enter SID",
                                            pattern: {
                                                value: /^[0-9]+$/,
                                                message: "Only Numeric characters are allowed",
                                            },
                                            minLength: {
                                                value: 10,
                                                message: "SID length 10 characters",
                                            },
                                            maxLength: {
                                                value: 10,
                                                message: "SID length 10 characters",
                                            },
                                        })}
                                    />
                                    <label htmlFor="address">Enter SID</label>
                                </div>
                                {errors.sid && (
                                    <small className="required">{errors.sid.message}</small>
                                )}
                            </div>
                            <div className="form-group-hotel col-4 mb-0">
                                <div className="floating-label">
                                    <input
                                        id="cdsn"
                                        placeholder=""
                                        {...register("cdsn", {
                                            required: "Please Enter CDSN",
                                            pattern: {
                                                value: /^[0-9]+$/,
                                                message: "Only Numeric characters are allowed",
                                            },
                                            minLength: {
                                                value: 11,
                                                message: "CDSN length 11 characters",
                                            },
                                            maxLength: {
                                                value: 11,
                                                message: "CDSN length 11 characters",
                                            },
                                        })}
                                    />
                                    <label htmlFor="address">Enter CDSN</label>
                                </div>
                                {errors.cdsn && (
                                    <small className="required">{errors.cdsn.message}</small>
                                )}
                            </div>
                            <button type="submit" className={`create-btn col-3 ${errors?.cdsn || errors?.sid ? 'mb-4' : 'mb-0'}`}>Search</button>
                        </div>
                    </form>
                </div>
            </div>
            {initialLoad ? (
                cdsnDetails?.status === 1 ? (
                    <div className="cdsn-details-not-found" >
                        <img src="/Images/no-data-icon.png" alt="no data found" />
                        <p>{cdsnDetails?.message}!</p>
                    </div>
                ) : Object.keys(cdsnDetails).length > 0 ? (<><div className='config-hotel'>
                    <div className='left-column'>
                        <div className="hotel-list mt-3">
                            <div className="flex-item mb-3 justify-content-between">
                                <p className="mb-0"><b>CDSN Details</b></p>
                                <div className="d-flex">
                                    {cdsnFetchNowLoader && <p className="text-danger mx-2 mb-0 mt-2">* Fetch Now in Progress. Leaving the page will interrupt current fetch now.</p>}
                                <Tooltip title={`${cdsnFetchNowLoader ? "Fetch Now in Progress" : "Fetch Now"}`} arrow>
                                    <div>
                                        <button onClick={triggerFetchNow} type="button" className={`${cdsnFetchNowLoader ? "opacity-50 pe-none" : ""} un-published`}>
                                            {cdsnFetchNowLoader ? <img
                                                src="/Images/rotate.png"
                                                width="25"
                                                className="loaderIcon mr-1"
                                            /> : ""} Fetch Now </button>
                                    </div>
                                </Tooltip>
                                </div>
                            </div>
                            <TableWrapper
                                data={Object.keys(cdsnDetails).length > 0 ? [cdsnDetails] : cdsnDetails}
                                columns={columns}
                                noPagination={true}
                            />
                        </div>
                    </div>
                </div>
                    <STBApkDetails flag={flag} cdsn={cdsn} sid={sid} />
                    <PackDetails flag={flag} cdsn={cdsn} sid={sid} /></>) : null
            ) : null}
        </div >
    )
}

export default FetchCDSNDetailsAdmin;